/* Form validation (design system web.md §7): check when a field is left and on submit, never while typing.
   Errors: 2px terracotta border (.has-error), info icon and one sentence saying how to fix it.
   Applies to every <form data-validate> and form.fp-validate (Shopify form tags cannot set data attributes). Messages come from each field's data-error-message (locale files). */
(function () {
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function wrap(input) { return input.closest("[data-field]"); }
  function invalid(input) {
    if (input.type === "checkbox") return input.required && !input.checked;
    var v = (input.value || "").trim();
    if (input.required && !v) return true;
    if (input.type === "email" && v && !EMAIL.test(v)) return true;
    return false;
  }
  function show(input, bad) {
    var field = wrap(input);
    if (!field) return;
    var err = field.querySelector(".fp-field__error");
    field.classList.toggle("has-error", bad);
    if (bad) input.setAttribute("aria-invalid", "true"); else input.removeAttribute("aria-invalid");
    if (err) {
      err.hidden = !bad;
      var t = err.querySelector("[data-error-text]");
      if (bad && t) t.textContent = input.dataset.errorMessage || "";
    }
  }
  function check(input) { var bad = invalid(input); show(input, bad); return !bad; }
  function fields(form) { return form.querySelectorAll("input[data-error-message], select[data-error-message], textarea[data-error-message]"); }

  function bind(form) {
    if (form.dataset.validateBound) return;
    form.dataset.validateBound = "1";
    form.setAttribute("novalidate", "");
    fields(form).forEach(function (input) {
      input.addEventListener("blur", function () { if (input.type !== "checkbox") check(input); });
      input.addEventListener("change", function () { if (input.type === "checkbox" || input.tagName === "SELECT") check(input); });
      // Once a field shows an error, clear it as soon as it becomes valid (no new errors while typing).
      input.addEventListener("input", function () { if (wrap(input) && wrap(input).classList.contains("has-error") && !invalid(input)) show(input, false); });
    });
    form.addEventListener("submit", function (e) {
      var firstBad = null;
      fields(form).forEach(function (input) { if (!check(input) && !firstBad) firstBad = input; });
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
    });
  }
  function init(root) { (root || document).querySelectorAll("form[data-validate], form.fp-validate").forEach(bind); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
